interface Typography {
    fontSize: string;
    fontWeight?: string | number;
    lineHeight?: string | number;
    letterSpacing?: string | number;
}

// interface TailwindTypography {}

export const typography:Record<string, Typography> = {
    h1: {
        fontSize: 'var(--v-theme-typography-h1-size, 3rem)',
        fontWeight: 'var(--v-theme-typography-h1-weight, 700)',
        lineHeight: 'var(--v-theme-typography-h1-line-height, 1.167)',
        letterSpacing: 'var(--v-theme-typography-h1-letter-spacing, -0.01562em)',
    },
    h2: {
        fontSize: 'var(--v-theme-typography-h2-size, 2.7rem)',
        fontWeight: 'var(--v-theme-typography-h2-weight, 300)',
        lineHeight: 'var(--v-theme-typography-h2-line-height, 1.2)',
        letterSpacing: 'var(--v-theme-typography-h2-letter-spacing, -0.00833em)',
    },
    h3: {
        fontSize: 'var(--v-theme-typography-h3-size, 2.125rem)',
        fontWeight: 'var(--v-theme-typography-h3-weight, 700)',
        lineHeight: 'var(--v-theme-typography-h3-line-height, 1.167)',
        letterSpacing: 'var(--v-theme-typography-h3-letter-spacing, 0em)',
    },
    h4: {
        fontSize: 'var(--v-theme-typography-h4-size, 2.125rem)',
        fontWeight: 'var(--v-theme-typography-h4-weight, 400)',
        lineHeight: 'var(--v-theme-typography-h3-line-height, 1.235)',
        letterSpacing: 'var(--v-theme-typography-h4-letter-spacing, 0.00735em)',
    },
    h5: {
        fontSize: 'var(--v-theme-typography-h5-size, 1.5rem)',
        fontWeight: 'var(--v-theme-typography-h5-weight, 400)',
        lineHeight: 'var(--v-theme-typography-h5-line-height, 1.334)',
        letterSpacing: 'var(--v-theme-typography-h5-letter-spacing, 0em)',
    },
    h6: {
        fontSize: 'var(--v-theme-typography-h6-size, 1.25rem)',
        fontWeight: 'var(--v-theme-typography-h6-weight, 500)',
        lineHeight: 'var(--v-theme-typography-h6-line-height, 1.6)',
        letterSpacing: 'var(--v-theme-typography-h6-letter-spacing, 0.00938em)',
    },
    subtitle: {
        fontSize: 'var(--v-theme-typography-subtitle-size, 1rem)',
        fontWeight: 'var(--v-theme-typography-subtitle-weight, 400)',
        lineHeight: 'var(--v-theme-typography-subtitle-line-height, 1.75)',
        letterSpacing: 'var(--v-theme-typography-subtitle-letter-spacing, 0.00938em)',
    },
    subtitle1: {
        fontSize: 'var(--v-theme-typography-subtitle1-size, 1rem)',
        fontWeight: 'var(--v-theme-typography-subtitle1-weight, 400)',
        lineHeight: 'var(--v-theme-typography-subtitle1-line-height, 1.75)',
        letterSpacing: 'var(--v-theme-typography-subtitle1-letter-spacing, 0.00938em)',
    },
    subtitle2: {
        fontSize: 'var(--v-theme-typography-subtitle2-size, 0.875rem)',
        fontWeight: 'var(--v-theme-typography-subtitle2-weight, 500)',
        lineHeight: 'var(--v-theme-typography-subtitle2-line-height, 1.57)',
        letterSpacing: 'var(--v-theme-typography-subtitle2-letter-spacing, 0.00714em)',
    },
    body: {
        fontSize: 'var(--v-theme-typography-body-size, 1rem)',
        fontWeight: 'var(--v-theme-typography-body-weight, 400)',
        lineHeight: 'var(--v-theme-typography-body-line-height, 1.5)',
        letterSpacing: 'var(--v-theme-typography-body-letter-spacing, 0.00938em)',
    },
    body1: {
        fontSize: 'var(--v-theme-typography-body1-size, 1rem)',
        fontWeight: 'var(--v-theme-typography-body1-weight, 400)',
        lineHeight: 'var(--v-theme-typography-body1-line-height, 1.5)',
        letterSpacing: 'var(--v-theme-typography-body1-letter-spacing, 0.00938em)',
    },
    body2: {
        fontSize: 'var(--v-theme-typography-body2-size, 0.875rem)',
        fontWeight: 'var(--v-theme-typography-body2-weight, 400)',
        lineHeight: 'var(--v-theme-typography-body2-line-height, 1.43)',
        letterSpacing: 'var(--v-theme-typography-body2-letter-spacing, 0.01071em)',
    },
    button: {
        fontSize: 'var(--v-theme-typography-button-size, 0.875rem)',
        fontWeight: 'var(--v-theme-typography-button-weight, 500)',
        lineHeight: 'var(--v-theme-typography-button-line-height, 1.75)',
        letterSpacing: 'var(--v-theme-typography-button-letter-spacing, 0.02857em)',
    },
    caption: {
        fontSize: 'var(--v-theme-typography-caption-size, 0.75rem)',
        fontWeight: 'var(--v-theme-typography-caption-weight, 400)',
        lineHeight: 'var(--v-theme-typography-caption-line-height, 1.66)',
        letterSpacing: 'var(--v-theme-typography-caption-letter-spacing, 0.03333em)',
    },
    overline: {
        fontSize: 'var(--v-theme-typography-overline-size, 0.75rem)',
        fontWeight: 'var(--v-theme-typography-overline-weight, 400)',
        lineHeight: 'var(--v-theme-typography-overline-line-height, 2.66)',
        letterSpacing: 'var(--v-theme-typography-overline-letter-spacing, 0.08333em)',
    },
}

export const theme = {
    cssVarPrefix: 'v',
}

export const transTailwindFontSize = (typography:Record<string, Typography>) => {
    try {
        const obj:Record<string, [string, object]> = {}
        Object.entries(typography).forEach(([key, item]) => {
            const fontSize = item.fontSize;
            const nItem:Record<string, any> = {...item}
            delete nItem?.fontSize;

            obj[key] = [fontSize, nItem];
        })

        return obj;

    } catch (e) {
        console.error(e);
    }
}

console.log('typography', transTailwindFontSize(typography))

const tailwindTypography = transTailwindFontSize(typography);

export default {
    typography,
    tailwindTypography,
    transTailwindFontSize,
}